type Props = {
    location?: string,
};

export const NavigateToAWebsite = ({ location }: Props) => {
    if (location) {
        window.location.replace(location);
        return;
    }

    window.location.reload();

    return <></>;
};
